import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newCargos({state}) {
    let cargoDetails = {
      fileopening_id: $(".fileopening_id").val(),
      cargos: state.cargos
    };
  
    $(".creatingCargo").hide();
    $(".creatingCargoLoader").show();
    baseurl.post(rt.newCargo, cargoDetails).then(res => {
      $(".creatingCargo").show();
      $(".creatingCargoLoader").hide();

      //checking for response codes from backend api

      if (res.data.code === 200) {
        //success code
        suc.cargoCreateSuccess();
        router.push('/managefileopenings')
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 403) {
        //cargo exits
        ers.CargoentryExists();
      } else if (res.data.code === 404) {
        //error on  creating cargo
        ers.errorCreatingCargoentry();
      } else if (res.data.code === 405) {
        //no permission to create
        ers.noPermissionToCreate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired code
        ses.sessionComplete();
      }
    });
  },

  loadCargos({ commit }) {
    baseurl.get(rt.loadCargo).then(res => {
      $(".cargosLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code and commiting data
        commit("STORE_CARGOS", res.data.cargoentries);
      } else if (res.data.code === 404) {
        //error on loading cargo entries
        ers.errorLoadingCargoentry();
      } else if (res.data.code === 405) {
        //no permission to read
        commit("STORE_CARGOS", []);
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired code
        ses.sessionComplete();
      }
    });
  },

  loadFileopeningCargos({ commit }) {
    baseurl.get(rt.loadCarg).then(res => {
      $(".fileopeningLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code and commiting data
        commit("STORE_FILEOPENING", res.data.fileopeningcargos);
      } else if (res.data.code === 404) {
        //error on loading cargo entries
        ers.errorLoadingCargoentry();
      } else if (res.data.code === 405) {
        //no permission to read
        commit("STORE_FILEOPENING", []);
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired code
        ses.sessionComplete();
      }
    });
  },

  viewCargo({ commit }, cargoId) {
    commit("STORE_CARGO_UPDATE", cargoId);
    router.push("/updatecargoentry");
  },
  fileShipping({commit},fileopeningId){
    commit("STORE_CARGOS_UPDATE", fileopeningId);
    router.push('/newshippingdetail')

   },

  cargoUpdate({ commit }) {
    let cargoDetails = {
      id: $(".id").val(),
      fileopening_id: $(".fileopening_id").val(),
      container_no: $(".container_no").val(),
      cargo_size: $(".cargo_size").val(),
      weight_units: $(".weight_units").val(),
      net_weight: $(".net_weight").val(),
    };

    $(".updatingCargo").hide();
    $(".updatingCargoLoader").show();

    baseurl.post(rt.updateCargo, cargoDetails).then(res => {
      $(".updatingCargo").show();
      $(".updatingCargoLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //succes codes
        suc.cargoUpdateSuccess();
        commit("STORE_CARGOS", res.data.cargoentries);
        setTimeout(() => {
          router.push("/managecargoentries");
        }, 3000);
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 404) {
        //error on updating cargo entry
        ers.errorUpdatingCargoentry();
      } else if (res.data.code === 405) {
        //no permission to update
        ers.noPermissionToUpdate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/cargoentries/actions.js